import React from "react";

import RichText from "../CmsComponents/RichText/RichText";
import { BNStack } from "@bn-monorepo/js-packages";
import { Typography } from "@mui/material";
import SectionWrapper from "./SectionPage/components/Section/SectionWrapper";

interface Props {
  question: string;
  answer: string;
}

const Question: React.FC<Props> = ({ question, answer }) => (
  <SectionWrapper noImage anchorId="" backgroundColor={"transparent"}>
    <BNStack
      sx={{
        gap: 2,
      }}
    >
      <Typography component={"h1"} variant="h4">
        {question}
      </Typography>
      <RichText html={answer} />
    </BNStack>
  </SectionWrapper>
);

export default Question;
